var _metadata, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActiveGigbusiness(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "17pt",
    height: "17pt",
    viewBox: "0 0 99.000000 99.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by potrace 1.16, written by Peter Selinger 2001-2019\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,99.000000) scale(0.100000,-0.100000)",
    fill: "#595757",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M290 900 c-20 -17 -25 -32 -28 -85 l-4 -65 -98 0 c-147 0 -140 15 -140 -317 l0 -265 30 -29 30 -30 382 3 c412 3 397 1 461 58 45 39 57 72 57 151 0 69 -2 75 -40 125 -22 29 -49 55 -60 59 -18 6 -20 15 -20 99 0 85 -2 95 -25 120 -23 25 -29 26 -125 26 l-100 0 0 58 c0 45 -5 65 -21 83 -19 23 -28 24 -147 27 -118 3 -129 2 -152 -18z m470 -314 c0 -64 0 -64 -32 -71 -18 -4 -52 -28 -81 -57 l-49 -49 4 -99 3 -100 -247 0 -248 0 0 220 0 220 325 0 325 0 0 -64z m107 -151 c85 -56 81 -189 -8 -237 -95 -51 -203 14 -203 121 0 107 122 174 211 116z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M815 350 c-48 -49 -49 -49 -69 -31 -34 30 -42 31 -61 11 -16 -18 -15 -20 25 -64 24 -25 46 -46 51 -46 4 0 40 32 80 70 70 69 71 71 54 90 -10 11 -21 20 -24 20 -4 0 -29 -22 -56 -50z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveGigbusiness);
export default __webpack_public_path__ + "static/media/ActiveGigbusiness.35225ddd.svg";
export { ForwardRef as ReactComponent };